import { Response } from "~/shared/api";

const zRes401 = Response.Schema.zNoBody(401);

export { zRes401 };
